export const Gallery = (props) => {
  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>VIDEO TUTORIAL</h2>
          <p style={{ textAlign: 'justify'}}>
          El siguiente video explica el proceso que se debe seguir para realizar la solicitud de autorización de uso de vidrios oscurecidos y polarizados.
          </p>
        </div>
        <div className='row'>
          <div className='portfolio-items'>
            {/* {props.data
              ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-sm-6 col-md-4 col-lg-4'>
                  <Image title={d.title} largeImage={d.largeImage} smallImage={d.smallImage} />
                </div>
              ))
              : 'Loading...'} */}
              <video controls src="img/portfolio/videoVidrios.mp4" ></video>

          </div>
        </div>
      </div>
    </div>
  )
}
